module.exports = __webpack_public_path__ + "img/1.85464f48.png";